import { Component, Input, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { ProviderInfo } from 'src/app/obstacle/model/provider-info.model'
import { Layers } from 'src/app/shared/layers-config/layers'

const COLLAPSED_STORAGE_KEY = 'obstacle-provider8-data-collapsed'

@Component({
  selector: 'app-obstacle-provider8-data',
  templateUrl: './obstacle-provider8-data.component.html',
  standalone: false,
})
export class ObstacleProvider8DataComponent implements OnInit {
  public layerIds = Layers
  public isAccidentsLayerVisible: boolean | undefined
  public isBdvVisible: boolean | undefined
  public isWDWVisible: boolean | undefined
  public isSVVisible: boolean | undefined
  public isCSVisible: boolean | undefined

  public isCollapsed = true
  @Input() providerInfo$!: Observable<ProviderInfo>

  constructor(private appState: AppStateService) {
    const layers = this.appState.selectLayers()
    this.isAccidentsLayerVisible = layers?.some((layer) => layer === Layers.Provider8Accidents.name)
    this.isBdvVisible = layers?.some((layer) => layer === Layers.Provider8Bdv.name)
    this.isWDWVisible = layers?.some((layer) => layer === Layers.Provider8Wdw.name)
    this.isSVVisible = layers?.some((layer) => layer === Layers.Provider8Sv.name)
    this.isCSVisible = layers?.some((layer) => layer === Layers.Provider8Cs.name)
  }

  ngOnInit(): void {
    this.isCollapsed = this.getStoredCollapsedState()
  }

  get selectedLayerCount(): number {
    return [
      this.isAccidentsLayerVisible,
      this.isBdvVisible,
      this.isWDWVisible,
      this.isSVVisible,
      this.isCSVisible,
    ].filter(Boolean).length
  }

  get allLayerCount(): number {
    return [
      this.isAccidentsLayerVisible,
      this.isBdvVisible,
      this.isWDWVisible,
      this.isSVVisible,
      this.isCSVisible,
    ].length
  }

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed
    this.storeCollapsedState()
  }

  toggleLayerVisbility(layerId: string) {
    switch (layerId) {
      case Layers.Provider8Accidents.name:
        this.isAccidentsLayerVisible = !this.isAccidentsLayerVisible
        break
      case Layers.Provider8Bdv.name:
        this.isBdvVisible = !this.isBdvVisible
        break
      case Layers.Provider8Wdw.name:
        this.isWDWVisible = !this.isWDWVisible
        break
      case Layers.Provider8Sv.name:
        this.isSVVisible = !this.isSVVisible
        break
      case Layers.Provider8Cs.name:
        this.isCSVisible = !this.isCSVisible
        break
      default:
        break
    }
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    const layers = this.appState
      .selectLayers()
      .filter(
        (layer) =>
          !(layer == Layers.Provider8Accidents.name) &&
          !(layer == Layers.Provider8Bdv.name) &&
          !(layer == Layers.Provider8Wdw.name) &&
          !(layer == Layers.Provider8Sv.name) &&
          !(layer == Layers.Provider8Cs.name),
      )
    if (this.isAccidentsLayerVisible) {
      layers.push(Layers.Provider8Accidents.name)
    }

    if (this.isBdvVisible) {
      layers.push(Layers.Provider8Bdv.name)
    }
    if (this.isWDWVisible) {
      layers.push(Layers.Provider8Wdw.name)
    }
    if (this.isSVVisible) {
      layers.push(Layers.Provider8Sv.name)
    }
    if (this.isCSVisible) {
      layers.push(Layers.Provider8Cs.name)
    }

    this.appState.setState(AppPaths.Obstacle, {
      layers: layers?.toString(),
    })
  }

  private getStoredCollapsedState(): boolean {
    if (typeof localStorage === 'undefined') {
      return true
    }

    const storedState = localStorage.getItem(COLLAPSED_STORAGE_KEY)

    if (storedState === null) {
      return true
    }

    return storedState === 'true'
  }

  private storeCollapsedState(): void {
    if (typeof localStorage === 'undefined') {
      return
    }

    localStorage.setItem(COLLAPSED_STORAGE_KEY, String(this.isCollapsed))
  }
}
